import { z } from "zod";

import type { Maybe } from "@/lib/gql/__generated__/graphql";
import { LangCode } from "@/lib/gql/__generated__/graphql";

const URL = "https://api.zipaddress.net";
const ZIPCODE_PARAM = "?zipcode=";
const LANG_PARAM = "&lang=";

type LangParamType = "ja" | "rome";

type PostalCodeAPIResponse = {
	code: "200" | "400" | "404" | "500";
	data: {
		pref: string;
		address: string;
		fullAddress: string;
		city: string;
		town: string;
	};
	message?: string;
};

const regExp1 = /^[0-9]{3}-[0-9]{4}$/g;
const regExp2 = /^[0-9]{3}[0-9]{4}$/g;
export const postalCodeSchema = z
	.string()
	.regex(regExp1, { message: "郵便番号の形式（000-0000, 0000000）で入力してください" })
	.or(z.string().regex(regExp2, { message: "郵便番号の形式（1111111）で入力してください" }));

export const fetchAddressByPostalCode = async (
	postalCode: Maybe<string> | undefined = "", //
	langCode: LangCode = LangCode.Default,
) => {
	if (postalCode) {
		postalCode = postalCode.replace("-", "");
	}

	const lang: LangParamType = langCode === LangCode.Default ? "ja" : "rome";

	const zodResponse = postalCodeSchema.safeParse(postalCode);

	if (!zodResponse.success) return;

	const res = await fetch(`${URL}/${ZIPCODE_PARAM}${postalCode}${LANG_PARAM}${lang}`, {
		method: "GET",
		mode: "cors",
	})
		.then((res) => (res.body as ReadableStream).getReader())
		.then(async (reader) => {
			const data = await reader.read().then((readableStreamReadResult: ReadableStreamReadResult<Uint8Array>) => {
				const { value } = readableStreamReadResult;
				const decoder = new TextDecoder("utf-8");

				if (value) {
					return JSON.parse(decoder.decode(value)) as PostalCodeAPIResponse;
				}
			});

			return data;
		});

	if (res) {
		if (langCode === LangCode.En) {
			const data = res.data;

			const addressArr = data?.address?.split(" ") ?? [];
			const reverseAddressArr = [...addressArr].reverse();

			reverseAddressArr.map((item) => {
				if (item.includes("-")) {
					if (!data.city) {
						data.city = item;
					} else {
						data.city += ", " + item;
					}
				} else {
					if (!data.town) {
						data.town = item;
					} else {
						data.town += ", " + item;
					}
				}
			});
		}
	}

	return {
		address: res,
	};
};

// export const usePostalCode = (
// 	postalCode: Maybe<string> | undefined = "", //
// 	langCode: LangCode = LangCode.Default,
// ): { postalCode: PostalCodeAPIResponse | null } => {
// 	if (postalCode) {
// 		postalCode = postalCode.replace("-", "");
// 	}

// 	const [response, setResponse] = useState<PostalCodeAPIResponse | null>(null);

// 	const lang: LangParamType = langCode === LangCode.Default ? "ja" : "rome";

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				postalCodeSchema.parse(postalCode);
// 				const res = await fetch(`${URL}/${ZIPCODE_PARAM}${postalCode}${LANG_PARAM}${lang}`, {
// 					method: "GET",
// 					mode: "cors",
// 				})
// 					.then((res) => (res.body as ReadableStream).getReader())
// 					.then(async (reader) => {
// 						const data = await reader
// 							.read()
// 							.then((readableStreamReadResult: ReadableStreamReadResult<Uint8Array>) => {
// 								const { value } = readableStreamReadResult;
// 								const decoder = new TextDecoder("utf-8");

// 								if (value) {
// 									return JSON.parse(decoder.decode(value)) as PostalCodeAPIResponse;
// 								}
// 							});

// 						return data;
// 					});

// 				if (res) {
// 					if (langCode === LangCode.En) {
// 						const data = res.data;

// 						const addressArr = data.address.split(" ");
// 						const reverseAddressArr = [...addressArr].reverse();

// 						reverseAddressArr.map((item) => {
// 							if (item.includes("-")) {
// 								if (!data.city) {
// 									data.city = item;
// 								} else {
// 									data.city += ", " + item;
// 								}
// 							} else {
// 								if (!data.town) {
// 									data.town = item;
// 								} else {
// 									data.town += ", " + item;
// 								}
// 							}
// 						});

// 						setResponse({
// 							...res,
// 							data,
// 						});
// 					}

// 					setResponse(res);
// 				}
// 			} catch (e) {
// 				/* empty */
// 			}
// 		};

// 		fetchData();
// 	}, [lang, langCode, postalCode]);

// 	return {
// 		postalCode: response,
// 	};
// };
